module.exports = __webpack_public_path__ + "static/media/male_body.de629233.png";